export default __webpack_public_path__ + "static/media/forgot_password_cover.62574b08.svg";